// GENERATED by scripts/build-icons.mjs from icons/plug-zap.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const PlugZap = createIcon('plug-zap', [
  ['path', { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z" }],
  ['path', { d: "m2 22 3-3" }],
  ['path', { d: "M7.5 13.5 10 11" }],
  ['path', { d: "M10.5 16.5 13 14" }],
  ['path', { d: "m18 3-4 4h6l-4 4" }],
])
